import { NavLink } from 'react-router-dom';
import { t } from '@/i18n';
import styles from './BottomNav.module.css';

const items = [
  { to: '/', label: t.nav.home, icon: String.fromCodePoint(0x1f3e0) },
  { to: '/spread', label: t.nav.spreadShort, icon: String.fromCodePoint(0x1f3b4) },
  { to: '/result', label: t.nav.result, icon: String.fromCodePoint(0x1f4cb) },
  { to: '/profile', label: t.nav.profile, icon: String.fromCodePoint(0x1f464) },
] as const;

export function BottomNav() {
  return (
    <nav className={styles.bnav} aria-label={t.nav.ariaMain}>
      {items.map((it) => (
        <NavLink
          key={it.to}
          to={it.to}
          className={({ isActive }) => [styles.nb, isActive ? styles.active : ''].filter(Boolean).join(' ')}
          end={it.to === '/'}
        >
          <span className={styles.ni} aria-hidden>
            {it.icon}
          </span>
          <span>{it.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
